<template>
  <div class="p-14 flex flex-col items-center justify-center">
    <GroupsCreationIcon :color="color.hex" class="mb-8" />
    <p class="text-body-6 text-default-1 text-center mb-2">
      {{ type === 'edit' ? "You’ve updated the group successfully!" : "You've created the group successfully!."}}
    </p>
    <p class="text-body-6 text-default-1 text-center mb-6">
      You can edit group settings at any time.
    </p>
    <CoreButton buttonType="primary" label="Got it!" size="default" @click="closeModal" />
  </div>
</template>
<script setup>
import CoreButton from '../../core/Button.vue';
import GroupsCreationIcon from '../../icons/GroupsCreation.vue';
import {useTheme} from "@/stores/ThemeStore";
import router from "@/router";

const themeStore = useTheme();
const emit = defineEmits(['close']);
const props = defineProps(['show', 'type']);
const { color } = themeStore;

function closeModal() {
    emit('close');
    router.push('/groups');
}
</script>